import React from "react";
import { Link } from "react-router-dom";

export default function PropertiesModal({
  setShowPropertiesModal,
  setIsClicked,
  data,
}) {
  return (
    <div
      className="inset-0 w-full h-full fixed z-[51] flex flex-col backdrop-blur-lg"
      onClick={(e) => {
        e.stopPropagation();
        setIsClicked(null);
        setShowPropertiesModal(false);
      }}
    >
      <div className="flex flex-col bg-white w-full h-full md:h-fit px-2 md:px-4 lg:px-8 xs:my-auto pt-4 pb-8 xl:max-w-6xl xl:mx-auto xl:h-fit xl:my-auto overflow-y-scroll">
        <div
          className="cursor-pointer self-end mb-4"
          onClick={(e) => {
            e.stopPropagation();
            setShowPropertiesModal(false);
            setIsClicked(null);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-6 text-black md:size-8"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        </div>

        <h3 className="font-[optima-lt-pro] text-xl md:text-3xl uppercase">
          Trending in Dubai Real Estate
        </h3>

        <div
          className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-8 mt-4 `}
        >
          {data?.map((item, index) => {
            return (
              <Link
                reloadDocument
                to={item?.featured_project_link}
                draggable="false"
                key={index}
                className={`flex flex-col gap-8 cursor-pointer`}
              >
                {/* Image */}
                <div className="w-full h-[200px] md:h-[200px]">
                  <img
                    src={
                      item?.featured_project_image?.formats?.medium?.url ||
                      item?.featured_project_image?.url
                    }
                    alt={item?.featured_project_image?.alternativeText}
                    className="w-full h-full object-cover object-center"
                    draggable="false"
                  />
                </div>

                {/* Bottom Section - Details */}
                <div>
                  <div className="flex flex-col gap-1">
                    <div className="flex flex-row items-center justify-between uppercase">
                      <p className="text-xs md:text-sm  text-gray-500 font-[lato] line-clamp-1">
                        {item?.featured_project_developer}
                      </p>
                      <p className="text-bhagwa text-xs md:text-sm font-[lato] uppercase line-clamp-1">
                        {item?.featured_project_price}
                      </p>
                    </div>
                    <h2 className="text-base md:text-lg uppercase font-normal font-[optima-lt-pro] line-clamp-1">
                      {item?.featured_project_name}
                    </h2>
                  </div>
                  <div className="flex items-center mt-1  space-x-2 text-sm md:text-base text-gray-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="size-4 md:size-4 xl:size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                      />
                    </svg>

                    <span className="font-[lato] text-xs md:text-sm line-clamp-1 uppercase">
                      {item?.featured_project_location}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
